export default {
    xhrFetchNotifications: '/notifications/xhr/onsite',
    xhrMarkReadCounter: '/notifications/xhr/onsite/mark-read-counter',
    xhrMarkAllRead: '/notifications/xhr/onsite/mark-all-read',
    notifications: '/notifications',
    notificationsWebsocketAuth: '/notifications/ws/auth'
};



// WEBPACK FOOTER //
// ./node_modules/@99designs/globalnav/src/data/urls.js